<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Warrior Heart</h1>
</div>
</div>
<h1 class="title">
	Warrior Heart</h1>
<h2 class="author">
	JANE BONANDER</h2>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap134657.vue?684a7b39